import type { TFunction } from 'i18next';

import type { FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import type { AbandonedCheckout } from '@nucleus-commerce/api-client/admin';

/** Fields GET /checkouts sorts on; anything else is a 400. */
export const ABANDONED_CHECKOUT_SORTS = ['lastActivityAt', 'total'] as const;

/**
 * The filters as the URL and the API spell them, for the route's search schema and loader. Any
 * `currency` marks `total` as whole minor units; the page shows it in the store's currency.
 */
export const ABANDONED_CHECKOUT_FILTER_FIELDS = [
  { key: 'recovered', type: 'boolean' },
  { key: 'recoveryEmailSent', type: 'boolean' },
  { key: 'total', type: 'number-range', currency: 'USD' },
  { key: 'lastActivityAt', type: 'date-range' },
] as const;

export interface AbandonedCheckoutFiltersOptions {
  /** The `abandonedCheckouts` namespace. */
  t: TFunction;
  currency: string;
}

/** Filters of the abandoned checkouts table, in the order the filter menu lists them. */
export function abandonedCheckoutFilters({
  t,
  currency,
}: AbandonedCheckoutFiltersOptions): Array<FilterDef<AbandonedCheckout>> {
  return [
    {
      key: 'recovered',
      label: t('filters.recovered'),
      type: 'boolean',
      pinned: true,
      trueLabel: t('filters.recoveredOnly'),
      falseLabel: t('filters.notRecovered'),
    },
    {
      key: 'recoveryEmailSent',
      label: t('filters.recoveryEmailSent'),
      type: 'boolean',
      pinned: true,
      aliases: ['emailSent'],
      trueLabel: t('filters.emailSent'),
      falseLabel: t('filters.emailNotSent'),
    },
    { key: 'total', label: t('filters.total'), type: 'number-range', currency, min: 0 },
    {
      key: 'lastActivityAt',
      label: t('filters.lastActivityAt'),
      type: 'date-range',
      aliases: ['lastActivity'],
    },
  ];
}
